import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AreaMaintenanceRoutingModule } from './area-maintenance-routing.module';
import { AreaMaintenanceComponent } from './area-maintenance.component';
import { AreaMaintenanceFormComponent } from './area-maintenance-form/area-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { AreaMaintenanceFilterComponent } from './area-maintenance-filter/area-maintenance-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    AreaMaintenanceRoutingModule
  ],
  declarations: [AreaMaintenanceComponent, AreaMaintenanceFormComponent, AreaMaintenanceFilterComponent],
  entryComponents: [AreaMaintenanceFilterComponent]
})
export class AreaMaintenanceModule { }
